import { IItinerary } from "@thekilroygroup/shared-ui";
import { RootState } from "../root.reducer";

export const shoppingCartSelector = (state: RootState) => state.shoppingCart;

export const getMostExpensivePaymentMethod = (itinerary: IItinerary) => {
  if (!itinerary) return null;
  const mostExpensivePaymentMethod = itinerary.paymentMethods.reduce(
    (orig, next) => (orig.total.amount > next.total.amount ? orig : next),
  );
  return mostExpensivePaymentMethod;
};

export const getCheapestPaymentMethod = (itinerary: IItinerary) => {
  if (!itinerary) return null;
  const cheapestPaymentMethod = itinerary.paymentMethods.reduce((orig, next) =>
    orig.total.amount < next.total.amount ? orig : next,
  );
  return cheapestPaymentMethod;
};

export const getVariableProductsTotal = (
  state: RootState,
  itinerary: IItinerary,
) => {
  // Get selected products total + itinerary total
  if (!itinerary) return 0;

  const whiteListKeys = ["studentCard", "CO2COMP", "BAGASPROD"];
  const variableProductsTotal = state.shoppingCart.paymentLines.reduce(
    (prev, current) => {
      if (whiteListKeys.includes(current.key)) {
        return prev + current.amount;
      } else {
        return prev;
      }
    },
    0,
  );

  return itinerary.totalFareAmounts.total + variableProductsTotal;
};

export const getLowestTotal = (state: RootState, itinerary: IItinerary) => {
  if (!itinerary) return 0;

  const totalPaymentLines = state.shoppingCart.paymentLines.reduce(
    (prev, current) => {
      return prev + current.amount;
    },
    0,
  );

  return itinerary.totalFareAmounts.total + totalPaymentLines;
};

export const getSubTotal = (state: RootState) => {
  const { indexOfRequestedItinerary, includesBrandedFares, itineraries } =
    state.selectedItinerary;
  const itinerary = includesBrandedFares
    ? itineraries[indexOfRequestedItinerary]
    : itineraries[0];

  if (!itinerary) return 0;

  const totalPaymentLines = state.shoppingCart.paymentLines.reduce(
    (prev, current) => {
      return prev + current.amount;
    },
    0,
  );
  return (
    itinerary.totalFareAmounts.total +
    totalPaymentLines +
    (getMostExpensivePaymentMethod(itinerary)?.fee || 0)
  );
};

export const getTotal = (state: RootState): number => {
  if (
    !state.selectedItinerary.itineraries[0] ||
    !state.shoppingCart.selectedPaymentMethod
  )
    return 0;
  return (
    getSubTotal(state) -
    state.shoppingCart.selectedPaymentMethod.discount.amount
  );
};
